/**
 * Static data reducer
 * @namespace static_data_reducer
 * @category Redux
 * @subcategory Reducers
 */
// eslint-disable-next-line
const static_data_reducer = {};
//used for the namespace in the documentation

/**
 * The initial shared state
 * @memberof static_data_reducer
 */
const initState = {
  chargers: [],
  cycleways: [],
  greenCorridor1: [],
  greenCorridor2: [],
  greenCorridor3: [],
  subwayStations: [],
  subwayLines: [],
  TMData: [],
  TBData: [],
  BData: [],
  filteredTMData: [],
  filteredTBData: [],
  filteredBData: [],
  //kanachkova
  reconstructionsTemporary: [],
  reconstructionsPermanent: [],
};

/**
 * Redux static data reducer
 * @category Redux
 * @subcategory Reducers
 * @memberof static_data_reducer
 * @function staticDataReducer
 * @param {object} state the state of the reducer
 * @param {object} action the actions for the reducer
 */

const staticDataReducer = (state = initState, action) => {
  switch (action.type) {
    //kanachkova
    case "SET_STATIC_DATA_RECONSTRUCTIONS_TEMPORARY":
      return {
        ...state,
        reconstructionsTemporary: action.payload,
      };
    //kanachkova
    case "SET_STATIC_DATA_RECONSTRUCTIONS_PERMANENT":
      return {
        ...state,
        reconstructionsPermanent: action.payload,
      };
    case "SET_STATIC_DATA_CHARGERS":
      return {
        ...state,
        chargers: action.payload,
      };
    case "SET_STATIC_DATA_CYCLEWAYS":
      return {
        ...state,
        cycleways: action.payload,
      };
    case "SET_STATIC_DATA_GREEN_CORRIDOR_ONE":
      return {
        ...state,
        greenCorridor1: action.payload,
      };
    case "SET_STATIC_DATA_GREEN_CORRIDOR_TWO":
      return {
        ...state,
        greenCorridor2: action.payload,
      };
    case "SET_STATIC_DATA_GREEN_CORRIDOR_THREE":
      return {
        ...state,
        greenCorridor3: action.payload,
      };
    case "SET_STATIC_DATA_SUBWAY_STATIONS":
      return {
        ...state,
        subwayStations: action.payload,
      };
    case "SET_STATIC_DATA_SUBWAY_LINES":
      return {
        ...state,
        subwayLines: action.payload,
      };
    case "SET_STATIC_DATA_TM":
      return {
        ...state,
        TMData: action.payload,
      };
    case "SET_STATIC_DATA_TB":
      return {
        ...state,
        TBData: action.payload,
      };
    case "SET_STATIC_DATA_B":
      return {
        ...state,
        BData: action.payload,
      };
    case "SET_STATIC_FILTERED_DATA_TM":
      return {
        ...state,
        filteredTMData: action.payload,
      };
    case "SET_STATIC_FILTERED_DATA_TB":
      return {
        ...state,
        filteredTBData: action.payload,
      };
    case "SET_STATIC_FILTERED_DATA_B":
      return {
        ...state,
        filteredBData: action.payload,
      };
    default:
      return state;
  }
};

export default staticDataReducer;
